import KaratClub from "@/assets/KaratClub.svg";
import { useEffect, useState } from "react";
import { WaitlistPopup } from "@/components/Waitlistpopup";
import { getOrCreateUserId } from "@/lib/session";
import { sendEvent } from "@/lib/googleSheet";
import { NavHashLink as Link } from 'react-router-hash-link';

// Assets for the "Hero-style" button
import Secondary from "@/assets/Hover-Bg-Secondary.png";
import lottibtn from "@/assets/PrimaryBg.json";
import { useLottie } from "lottie-react";
import { HoverBorderGradient } from "../components/ui/hover-border-gradient";

export const Header = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isHovering, setIsHovering] = useState(false);

  // Lottie Setup (Same as Hero)
  const options = {
    animationData: lottibtn,
    loop: true
  };
  const { View } = useLottie(options);

  const handleWaitlistClick = () => {
    const userId = getOrCreateUserId();
    sendEvent(userId, "JOIN_WAIT_LIST_CLICK_1").catch(() => { });
    window.location.href = "https://web.karatclub.in/";
    // setIsPopupOpen(true);

  };

  const navLinks = [
    { href: "/#whats_coming", label: "Discover" },
    { href: "/#how_it_works", label: "How It Works" },
    { href: "/#faq", label: "FAQ" }
  ];

  return (
    <>
      <header className="header border-none w-full bg-black">
        <div className="p-2 pl-4 pr-4 md:pl-10 md:pr-10 w-full border-b border-[#FFFFFF40] md:border-b-0">
          <div className="flex items-center justify-between w-full">

            {/* LOGO */}
            <div className="flex-shrink-0">
              <Link smooth to="/#top">
                <img src={KaratClub} alt="Karat Club" className="h-8 md:h-10 cursor-pointer" />
              </Link>
            </div>

            {/* NAV & BUTTONS */}
            <div className="flex items-center gap-4 md:gap-6 lg:gap-8">
              <div className="hidden md:flex items-center gap-4 lg:gap-6">
                {navLinks.map(link => (
                  <Link
                    key={link.href}
                    smooth
                    to={link.href}
                    className="nav-link text-white hover:text-[#DBAD71] whitespace-nowrap relative overflow-hidden group px-2"
                  >
                    <span className="relative inline-block">
                      <span className="block group-hover:-translate-y-full transition-transform duration-300 text-sm lg:text-base font-medium">
                        {link.label}
                      </span>
                      <span className="absolute top-0 left-0 text-[#DBAD71] translate-y-full group-hover:translate-y-0 transition-transform duration-300 text-sm lg:text-base font-medium">
                        {link.label}
                      </span>
                    </span>
                  </Link>
                ))}
              </div>

              {/* THE "HERO-STYLE" BUTTON FOR HEADER */}
              {/* THE "HERO-STYLE" BUTTON FOR HEADER */}
              <div className="flex-shrink-0">
                <HoverBorderGradient
                  onClick={handleWaitlistClick}
                  onMouseEnter={() => setIsHovering(true)}
                  onMouseLeave={() => setIsHovering(false)}
                  // 1. Force the inner content to center using flex
                  className="relative overflow-hidden cursor-pointer group !p-0 flex items-center justify-center bg-black"
                  containerClassName="rounded-[8px]"
                  style={{
                    border: "1px solid #313137",
                    height: "35px",
                    width: "150px",
                  }}
                >
                  {/* LOTTIE BACKGROUND */}
                  <div
                    className={`absolute inset-0 w-full h-full pointer-events-none transition-opacity duration-300 ${isHovering ? "opacity-0" : "opacity-100"
                      }`}
                  >
                    {/* 2. Increased scale to 2.0 ensures background covers all edges */}
                    <div className="w-full h-full scale-[2.0] flex items-center justify-center">
                      {View}
                    </div>
                  </div>

                  {/* IMAGE BACKGROUND */}
                  <img
                    src={Secondary}
                    alt=""
                    className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-300 ${isHovering ? "opacity-100" : "opacity-0"
                      }`}
                  />

                  {/* 3. CENTERED BUTTON TEXT */}
                  <span
                    className="relative z-10 text-white font-semibold whitespace-nowrap flex items-center justify-center"
                    style={{
                      fontSize: '14px',
                      // 4. Line height 1 is the secret to perfect vertical centering
                      lineHeight: '1',
                      height: '100%',
                      width: '100%',
                      textShadow: '0px 2px 4px rgba(0, 0, 0, 0.4)',
                    }}
                  >
                    Join the Club
                  </span>
                </HoverBorderGradient>
              </div>
            </div>
          </div>
        </div>
      </header>

      <WaitlistPopup
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
        onSubmit={(data) => console.log(data)}
      />
    </>
  );
};